// extracted by mini-css-extract-plugin
export default {"blocks":"Blocks_blocks__WYWMN","block":"Blocks_block__z-bbJ","icon":"Blocks_icon__SwuC3"};